<template>
    <div>
        <Snackbar v-if="errored" msg="Error from Server" />
        <Snackbar v-if="edited" msg="Operation Successfull" />
        <v-card-title>Edit Member</v-card-title>
        <v-col cols="12">
        <v-form ref="form" v-model="valid">
            <v-container>
            <v-row>
                <v-col
                cols="5"
                >
                    <v-text-field
                        v-model="fullName"
                        :rules="fullNameRules"
                        :loading="loading"
                        label="Full Name*"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                cols="4"
                >
                    <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        :loading="loading"
                        label="Email"
                        required
                    ></v-text-field>
                </v-col>                
                <v-col
                cols="3"
                >
                    <v-file-input
                        :rules="imageRules"
                        v-model="image"
                        show-size
                        accept="image/*"
                        label="Member photo"
                        clearable
                    ></v-file-input>
                </v-col>
                <v-col
                cols="2"
                >
                    <v-checkbox
                    v-model="active"
                    label="Active Member"
                    ></v-checkbox>
                </v-col>
                <v-col
                cols="3"
                >
                <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="startDate"
                    persistent
                    width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="startDate"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="startDate"
                    scrollable
                    :first-day-of-week="1"
                    locale="es-ES"
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="modal = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(startDate)"
                    >
                        OK
                    </v-btn>
                    </v-date-picker>
                </v-dialog>
                </v-col>
                <v-col
                cols="3"
                >
                <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="endDate"
                    persistent
                    width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="endDate"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :disabled="active"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="endDate"
                    scrollable
                    :first-day-of-week="1"
                    locale="es-ES"
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="modal = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(endDate)"
                    >
                        OK
                    </v-btn>
                    </v-date-picker>
                </v-dialog>
                </v-col>                
                <v-col
                cols="4"
                >
                    <v-text-field
                        v-model="link"
                        :rules="linkRules"
                        :loading="loading"
                        label="Personal page URL"
                    ></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-autocomplete
                    :rules="projectRules"
                    :items="projects"
                    :loading="loading"
                    :disabled="loading"
                    item-text="name"
                    label="Select a project"
                    dense
                    return-object
                    multiple
                    chips
                    v-model="project"
                    ></v-autocomplete>

                </v-col>
                <v-col cols="4">
                    <v-select
                    :rules="categoryRules"
                    :items="categories"
                    :loading="loading"
                    :disabled="loading"
                    item-text="name"
                    label="Select a category"
                    dense
                    return-object
                    multiple
                    chips
                    v-model="category"
                    ></v-select>

                </v-col>
                <v-col
                cols="4"
                >
                <v-text-field
                    v-model="degree"
                    :rules="degreeRules"
                    :loading="loading"
                    label="Degree"
                    required
                ></v-text-field>
                </v-col>
                <v-col
                cols="12"
                >
                <v-textarea
                    counter
                    v-model="description"
                    :loading="loading"
                    rows="3"
                    label="Description*"
                    required
                ></v-textarea>
                </v-col>
                <v-col cols="12">
                    <v-btn
                        depressed
                        :disabled="loading"
                        :loading="loading"
                        color="primary"
                        class="mr-4"
                        @click="submit"
                        >
                        Submit
                    </v-btn>
                </v-col>
            </v-row>
            </v-container>
        </v-form>
        </v-col>
    </div>
</template>
<script>
import axios from '../../plugins/axios'
import Snackbar from '@/components/Snackbar.vue'
export default {
    name: 'EditMember',
    components: {
        Snackbar
    },
	props: ['editId'],
    data: () => ({
        items: [],
        member: null,
        valid: false,
        loading: false,
        errored: false,
        edited: false,
        modal: false,
        image: null,
        fullName: '',
        degree: '',
        projects: [],
        categories: [],
        project: [],
        active: true,
        category: [],
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10),
        description: '',
        link: '',
        email: '',
        fullNameRules: [
            v => !!v || 'Full Name is required'
            // v => v.length <= 10 || 'title must be less than 10 characters',
        ],
        degreeRules: [
            v => !!v || 'Description is required'
        ],
        startDateRules: [
            v => !!v || 'Date is required'
        ],
        categoryRules: [
            v => v.length > 0 || 'Must have one category'
        ],
        emailRules: [
            v => v && v.length > 0 ? /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Not a valid Email' : true
        ],
        projectRules: [
            v => !!v || 'Project is required'
            // v => v.length <= 10 || 'title must be less than 10 characters',
        ],
        imageRules: [
            value => !value || value.size < 500000 || 'Image size should be less than 500 KB!',
        ],
        linkRules: [
            v => (!v || /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(v)) || 'Must be a valid link'
        ],
    }),

    mounted(){
        this.getMember();
    },
    methods: {
        async getMember(){
            this.loading = true
            axios
            .get(`/category/?section=Member`)
            .then(res => {
                this.categories = res.data.data
            })
            .catch(err => {
                console.error("axios err", err)
                this.errored = true
            });
            let r1 = axios.get('/member/byId/' + this.editId)
                    .then((res) => {
                        this.member = res.data.data;
                        this.fullName = this.member.fullName;
                        this.degree = this.member.degree;
                        this.project = this.member.projectsIds;
                        this.active = this.member.active;
                        this.startDate = this.member.startDate.substr(0, 10);
                        this.endDate = this.member.endDate ? this.member.endDate.substr(0, 10) : null;
                        this.description = this.member.description;
                        this.link = this.member.link;
                        this.email = this.member.email;
                        this.category = this.member.category;
                        this.image = this.member.image ? new File(this.member.image.data, this.fullName, {type: 'image/*'}) : null;
                    })
            let r2 = axios.get('/project/')
                    .then((res) => this.projects = res.data.data)
            await Promise.all([r1, r2])
            .then(() => this.loading = false)
            .catch(err => {
                console.error("axios err", err)
                this.errored = true
                this.loading = false
            })
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const fr = new FileReader()
                fr.readAsDataURL(file);
                fr.onload = () => resolve(fr.result);
                fr.onerror = error => reject(error);
            })
        },
        async submit () {
            this.errored, this.edited = false
            if(this.$refs.form.validate()){
                this.loading = !this.loading;
                let {fullName, degree, project, image,
                        active, startDate, endDate, description, link,
                        email, member, category} = this;
                let data = {
                    fullName, 
                    degree,
                    projectsIds: project,
                    active,
                    startDate,
                    endDate,
                    description,
                    link,
                    email,
                    category: category.map(c => c._id),
                }
                if(image){
                    let fileToBase64 = await this.toBase64(image)
                    data['image'] = fileToBase64
                }else{
                    data['image'] = null;
                }
                axios.put(`/member/`,
                    {
                        condition: {_id: member._id},
                        data
                    })
                    .then((res) => {
                        this.member = res.data.data;
                        this.edited = true;
                    })
                    .catch(err => {
                        console.error("error", err)
                        this.errored = true
                    })
                    .finally(() => {
                        this.loading = false
                    });
            }
        },

		reset () {
			this.$refs.form.reset();
		}
    },
    watch: {
        editId: function() {
			if(this.editId){
				this.getMember();
			}
        },

        image: function(){
            console.log(typeof(this.image), this.image);
        },

        active: function() {
            if(this.active){
                this.endDate = null;
            }
        }
    }            
}
</script>